import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UBC_COMMERCIAL_LIST_STATE_NAME } from './contants';
import { UbcCommercialListState } from './ubc-commercial-list.reducer';

const selectUBCCommercialListState =
  createFeatureSelector<UbcCommercialListState>(UBC_COMMERCIAL_LIST_STATE_NAME);

export const selectIsUpdatingBasketForCommercialList = createSelector(
  selectUBCCommercialListState,
  (state) => state?.updatingBasket,
);
